/**
 * districtPosters — which HD district planets have a captured poster on disk.
 *
 * GENERATED. Rewritten by `scripts/capture-planet-posters.mjs` from the files
 * actually sitting in `apps/web/public/assets/planet/posters/`, so the list can
 * never claim a still that isn't there. Edit the script, not this file.
 *
 * `posterHref` falls back to the city capture for any district missing here.
 * Bake some with:
 *   node scripts/capture-planet-posters.mjs --planets=hk:central-belt,tokyo:shibuya-belt
 */
export const DISTRICT_POSTER_IDS: readonly string[] = [];
